// extracted by mini-css-extract-plugin
module.exports = {"content":"Banner_content__0sS9Y"};